import { useTranslate } from "ra-core";

import { useIsMobile } from "@/hooks/use-mobile";

import { SegmentedControl } from "./SegmentedControl";
import { TASK_KIND_FILTERS, type TaskKindFilter } from "./taskKind";

const LABEL_KEYS: Record<TaskKindFilter, string> = {
  all: "resources.tasks.kind.all",
  internal: "resources.tasks.kind.internal",
  client: "resources.tasks.kind.client_short",
};

/** Todas / Interna / Cliente filter of the task lists. */
export const TaskKindFilterControl = ({
  value,
  onChange,
}: {
  value: TaskKindFilter;
  onChange: (value: TaskKindFilter) => void;
}) => {
  const translate = useTranslate();
  const isMobile = useIsMobile();
  return (
    <SegmentedControl
      value={value}
      onChange={onChange}
      label={translate("resources.tasks.kind.filter_label")}
      options={TASK_KIND_FILTERS.map((filter) => ({
        value: filter,
        label: translate(LABEL_KEYS[filter]),
      }))}
      glass={isMobile}
      size="sm"
      className="w-full md:max-w-xs"
    />
  );
};
